export default "__VITE_ASSET__DK9i5fxL__"